import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>🎉 Welcome to Deity — React Version</h1>
      <p>This is your live frontend, now powered by React.</p>
    </div>
  );
}

export default App;

